export const DIFF_AS_ONE = 'DIFF_AS_ONE'
export const DIFF_IGNORE = 'DIFF_IGNORE'

export const AUDIT_IGNORED_FIELDS = [
  'updatedBy',
  'updatedByName',
  'updatedByRole',
  'updatedAt',
  'setupProgressAt',
  'createdBy',
  'createdByName',
  'createdByRole',
  'createdAt',
]
